import { ArrowLeft, ArrowRight } from "lucide-react";
import { INLINE_ICON_PROPS } from "features/onboarding/common/onboardingUi";

export const NextArrow = () => <ArrowRight {...INLINE_ICON_PROPS} />;

export const BackArrow = () => <ArrowLeft {...INLINE_ICON_PROPS} />;
